import { REGEX_AMPERSAND, REGEX_PARENTHESIS, WHITESPACE_REGEX } from "./validation";

const CACHE_transformLegacySectionName: { [s: string]: string } = {};
export const transformLegacySectionName = (s: string): string => {
  if (!s) {
    s = "";
  }
  if (CACHE_transformLegacySectionName[s]) {
    return CACHE_transformLegacySectionName[s];
  }
  const v = s
    .replace(WHITESPACE_REGEX, "-")
    .replace(REGEX_PARENTHESIS, "")
    .replace(REGEX_AMPERSAND, "and")
    .toLowerCase();
  CACHE_transformLegacySectionName[s] = v;
  return v;
};
const CACHE_transformLegacyPageName: { [s: string]: string } = {};
export const transformLegacyPageName = (s: string): string => {
  if (!s) {
    s = "";
  }
  if (CACHE_transformLegacyPageName[s]) {
    return CACHE_transformLegacyPageName[s];
  }
  const v = s.replace(WHITESPACE_REGEX, "-").replace(REGEX_PARENTHESIS, "").toLowerCase();
  CACHE_transformLegacyPageName[s] = v;
  return v;
};
